import $ from './app/jquery-shim.js';
import Utils from './app/utils.js';
import Accordion from './app/accordion.js';
import Anchor from './app/anchor.js';
import FixedHeader from './app/fixedheader.js';
import HeightLine from './app/heightline.js';
import ResponsiveTable from './app/responsive-table.js';
import Slidebar from './app/slidebar.js';
import Tab from './app/tab.js';
import CurrentNav from './app/current-nav.js';
import buildFormat from './app/format.js';
import OwlCarousel from 'owl.carousel';
import ScrollReveal from 'scrollreveal';
import particleJS from 'particles.js';


import fontAwesome from "font-awesome/scss/font-awesome.scss"
import OwlCss from "owl.carousel/dist/assets/owl.carousel.css"
import OwlThemeCss from "owl.carousel/dist/assets/owl.theme.default.css"

import SlickCarousel from 'slick-carousel';
import SlickCarouselCss from "slick-carousel/slick/slick-theme.scss";
import SlickCarouselCsss from "slick-carousel/slick/slick.scss";


class App {
    constructor() {
        this.Utils = new Utils();
        this.Accordion = new Accordion();
        this.Anchor = new Anchor();
        this.FixedHeader = new FixedHeader();
        this.HeightLine = new HeightLine();
        this.ResponsiveTable = new ResponsiveTable();
        this.Slidebar = new Slidebar();
        this.CurrentNav = new CurrentNav();
        this.Tab = new Tab();


        function buildFormat() {
            var $toc = $('<div />', {id: 'toc_container'});
            var $list = $('<ul />', {class: 'toc_list'});
            var $groups = $('.u-format-group');
            // フォーマットグループごとの処理
            for (var i = 0; i < $groups.length; i++) {
                var $_list = $('<ul />');
                var $group = $($groups[i]);
                var group_title = $group.find('.u-format-group__title').text();
                var $group_li = $('<li />');
                var groupid = 'formatgroup_' + (i + 1);
                $group.attr('id', groupid);
                $list.append(
                    $group_li.append(
                        $('<a />',
                            {
                                text: (i + 1) + '. ' + group_title,
                                href: '#' + groupid
                            }
                        )
                    )
                );
                // フォーマットごとの処理
                var $formats = $group.find('.u-format-group__content').find('.u-format');
                var $_ul = $('<ul />');
                for (var m = 0; m < $formats.length; m++) {
                    var $format = $($formats[m]);
                    var $format_title = $format.find('.u-format__title');
                    var $format_content = $format.find('.u-format__content');
                    var formatid = 'format_' + (i + 1) + (m + 1);
                    $format.find('.u-format__title').attr('id', formatid);
                    var format_title = $format_title.text();
                    var format_number = (i + 1) + '.' + (m + 1) + '. ';
                    $format_title.text(format_number + format_title);
                    $_ul.append(
                        $('<li />').append(
                            $('<a />', {
                                    href: '#' + formatid,
                                    text: format_number + format_title
                                }
                            )
                        )
                    );

                    // コードを追加
                    var $code = $('<div />', {class: 'u-format__code'});
                    $code.append($('<div />', {
                        class: 'u-format__code__title',
                        text: format_number + format_title
                    }));
                    var formathtml = $format.find('.u-format__content').html();
                    $code.append($('<pre />', {text: formathtml.trim()}));
                    $format.append($code);
                }
                $group_li.append($_ul);
                $_list.append($group_li);
                $list.append($_list);
            }
            $toc.append($list);
            $('.c-breadcrumb').after(
                $('<div />', {
                        class: 'l-container'
                    }
                ).append($toc)
            );
        }


        function slick() {
            if ($(".c-post-content__inner, .c-variation-slide__main, .c-variation-slide__sub").length <= 0) {
                return;
            }
            $('.is-slider .c-post-content__inner').slick({
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 400,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                focusOnSelect: true,
                centerMode: true,
                centerPadding: '0',
                arrows: true,
                dots: false,
                prevArrow: '<div class="slick-prev" style="background-image:url(https://www.mitsufuji.co.jp/dist/assets/images/icon-slider-prev.svg)"></div>',
                nextArrow: '<div class="slick-next" style="background-image:url(https://www.mitsufuji.co.jp/dist/assets/images/icon-slider-next.svg)"></div>',
                responsive: [{
                    breakpoint: 750,
                    settings: {
                        autoplaySpeed: 2500,
                        slidesToShow: 1,
                    }
                }]
            });
            $('.is-service .c-post-content__inner').slick({
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 400,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                focusOnSelect: true,
                centerMode: true,
                centerPadding: '0',
                arrows: true,
                dots: false,
                prevArrow: '<div class="slick-prev" style="background-image:url(/wp-content/themes/mitsufuji/html/dist/assets/images/icon-slider-prev.svg)"></div>',
                nextArrow: '<div class="slick-next" style="background-image:url(/wp-content/themes/mitsufuji/html/dist/assets/images/icon-slider-next.svg)"></div>',
                responsive: [{
                    breakpoint: 750,
                    settings: {
                        autoplaySpeed: 2500,
                        slidesToShow: 1,
                    }
                }]
            });
            $('.is-performance .c-post-content__inner').slick({
                autoplay: true,
                autoplaySpeed: 4000,
                speed: 400,
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                focusOnSelect: true,
                centerMode: true,
                centerPadding: '0',
                arrows: true,
                dots: false,
                prevArrow: '<div class="slick-prev" style="background-image:url(/wp-content/themes/mitsufuji/html/dist/assets/images/icon-slider-prev.svg)"></div>',
                nextArrow: '<div class="slick-next" style="background-image:url(/wp-content/themes/mitsufuji/html/dist/assets/images/icon-slider-next.svg)"></div>',
                responsive: [{
                    breakpoint: 750,
                    settings: {
                        autoplaySpeed: 2500,
                        slidesToShow: 1,
                    }
                }]
            });
            $('.c-variation-slide__main').slick({
                infinite: true,
                slidesToShow: 1,
                variableWidth: false,
                slidesToScroll: 1,
                autoplay: true,
                arrows: true,
                prevArrow: '<div class="slick-prev" style="background-image:url(/wp-content/themes/mitsufuji/html/dist/assets/images/icon-slider-prev.svg)"></div>',
                nextArrow: '<div class="slick-next" style="background-image:url(/wp-content/themes/mitsufuji/html/dist/assets/images/icon-slider-next.svg)"></div>',
                asNavFor: '.c-variation-slide__sub',
                autoplaySpeed: 2500,
                cssEase: 'ease-in-out',
            });
            $('.c-variation-slide__sub').slick({
                accessibility: true,
                arrows: true,
                prevArrow: '<div class="slick-prev"><img src="/wp-content/themes/mitsufuji/html/dist/assets/images/icon-arrow-slider-prev.svg" /></div>',
                nextArrow: '<div class="slick-next"><img src="/wp-content/themes/mitsufuji/html/dist/assets/images/icon-arrow-slider-next.svg" /></div>',
                infinite: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                asNavFor: '.c-variation-slide__main',
                focusOnSelect: true,
                cssEase: 'ease-in-out',
                centerMode: true,
                centerPadding: '6.71%',
                responsive: [{
                    breakpoint: 750,
                    settings: {
                        slidesToShow: 3,
                        centerMode: true,
                    }
                }]
            });
        }

        /************************************
         * ミツフジの歴史スライダー
         ************************************/
        function futureSlider() {
            var owlFutureSlider = $('.c-future-slide .owl-carousel');
            if (owlFutureSlider.length !== 0) {
                owlFutureSlider.imagesLoaded(function () {

                    //start
                    function startProgressBar() {
                        $(".c-future-slide__progress").css({
                            width: "300px",
                            transition: "width 8000ms linear"
                        });
                    }

                    //元に戻す
                    function resetProgressBar() {
                        $(".c-future-slide__progress").css({
                            width: 0,
                            transition: "width 0s linear"
                        });
                    }

                    var $image = $(".c-future-slide__image");
                    var $image_sp = $(".c-future-slide__image-sp");
                    var $stage = $(".c-future-slide__stage");
                    var $title = $(".c-future-slide__title");
                    var $title_sp = $(".c-future-slide__title-sp");
                    var $text = $(".c-future-slide__text");
                    var $anim1 = 'is-anim1';
                    var $anim2 = 'is-anim2';
                    var $anim3 = 'is-anim3';
                    var $anim4 = 'is-anim4';

                    function startAnimation() {
                        $image.addClass($anim1);
                        $image_sp.addClass($anim1);
                        $stage.addClass($anim2);
                        $title.addClass($anim3);
                        $title_sp.addClass($anim3);
                        $text.addClass($anim4);
                    }

                    function endAnimation() {
                        $image.removeClass($anim1);
                        $image_sp.removeClass($anim1);
                        $stage.removeClass($anim2);
                        $title.removeClass($anim3);
                        $title_sp.removeClass($anim3);
                        $text.removeClass($anim4);
                    }

                    resetProgressBar();
                    startAnimation();

                    owlFutureSlider.owlCarousel({
                        items: 1,
                        margin: 0,
                        dots: true,
                        loop: true,
                        nav: true,
                        autoplaySpeed: 500,
                        autoplayTimeout: 9000,
                        autoplayHoverPause: false,
                        autoplay: true,
                        center: true,
                        onInitialized: startProgressBar,
                        navText: ['<img src="https://www.mitsufuji.co.jp/dist/assets/images/icon-arrow-slider-prev.svg" />', '<img src="https://www.mitsufuji.co.jp/dist/assets/images/icon-arrow-slider-next.svg" />'],
                    });
                    owlFutureSlider.on('translate.owl.carousel', function (e) {
                        resetProgressBar();
                        endAnimation();
                    });
                    owlFutureSlider.on('translated.owl.carousel', function (e) {
                        startProgressBar();
                        startAnimation();
                    });
                });
            }
        }


        /************************************
         * メインヴィジュアル (単一画像)
         ************************************/
        function mainVisualImage() {
            // var $el = $('.js-mainvisual-catchcopy'),
            //   $elChild = '.js-mainvisual-catchcopy-item',
            //   $elNameMain = '.js-mainvisual-catchcopy-text',
            //   $elNameSub = '.js-mainvisual-catchcopy-subtext',
            //   $elActive = 'is-active';
            //
            // if ($el.length === 0) {
            //   return false;
            // }
            // $(window).on('load', function () {
            //   $el.find($elChild).addClass($elActive).queue(function() {
            //     $el.find($elNameMain).addClass($elActive);
            //     setTimeout(function () {
            //       $el.find($elNameSub).addClass($elActive);
            //     }, 400);
            //   });
            // });

            var $elActive = 'is-active';
            var $image = Object(_app_jquery_shim_js__WEBPACK_IMPORTED_MODULE_0__["default"])('.c-main-visual-content__image');

            if ($image.length === 0) {
                return false;
            }

            // Object(_app_jquery_shim_js__WEBPACK_IMPORTED_MODULE_0__["default"])(window).on('load', function () {
            $image.find('.c-main-visual-content__image__green').addClass($elActive);
            $image.find('.c-main-visual-content__image__gray').addClass($elActive);
            $image.find('.c-main-visual-content__image__item').addClass($elActive);

            setTimeout(function () {
                var $el = Object(_app_jquery_shim_js__WEBPACK_IMPORTED_MODULE_0__["default"])('.js-mainvisual-catchcopy'),
                    $elChild = '.js-mainvisual-catchcopy-item',
                    $elNameMain = '.js-mainvisual-catchcopy-text',
                    $elNameSub = '.js-mainvisual-catchcopy-subtext';

                if ($el.length === 0) {
                    return false;
                }

                $el.find($elChild).addClass($elActive).queue(function () {
                    $el.find($elNameMain).addClass($elActive);
                    setTimeout(function () {
                        $el.find($elNameSub).addClass($elActive);
                    }, 400);
                });
            }, 1000);
            // });
        }


        /************************************
         * メインヴィジュアル (owlcarouselギャラリー)
         ************************************/
        function mainVisualSlider() {

            var $el = $('.c-main-visual');
            if ($el.length === 0) {
                return false;
            }

            /* オープニング背景画像 */
            $(window).on('load', function () {
                $('.c-main-visual__bg').addClass('is-active').queue(function () {
                    /* スライダー画像 */
                    var owlMainVisualImage = $('.c-main-visual__gallery .owl-carousel');
                    if (owlMainVisualImage.length !== 0) {
                        setTimeout(function () {
                            $(".c-main-visual__gallery").fadeOut(0);
                            owlMainVisualImage.imagesLoaded(function () {
                                owlMainVisualImage.owlCarousel({
                                    items: 1,
                                    margin: 0,
                                    dots: false,
                                    loop: true,
                                    nav: false,
                                    autoplaySpeed: 1000,
                                    autoplayTimeout: 4500,
                                    autoplayHoverPause: false,
                                    autoplay: true,
                                    center: true,
                                    onInitialized: changeClasses,
                                });
                                owlMainVisualImage.on('changed.owl.carousel', function (e) {
                                    changeClasses(e);
                                });

                                $(".c-main-visual__gallery").fadeIn(400, function () {
                                    var $target = $(document).find('.c-main-visual__catch__item').eq(0);
                                    var $targetChildMain = '.c-main-visual__catch__text';
                                    var $targetChildSub = '.c-main-visual__catch__subtext';

                                    $target.removeClass('is-active is-hidden');
                                    $target.addClass('is-active');
                                    $target.find($targetChildMain).addClass('is-active is-hidden');
                                    $target.find($targetChildSub).addClass('is-active is-hidden');

                                    // setTimeout(function () {
                                    //
                                    // }, 100);
                                });
                            });
                        }, 600);

                        /* コールバック関数 - 切り替わりのタイミング時 */
                        function changeClasses(e) {
                            var $target = $(document).find('.c-main-visual__catch__item'),
                                $targetChildMain = '.c-main-visual__catch__text',
                                $targetChildSub = '.c-main-visual__catch__subtext',
                                totalCount = e.item.count, //総数
                                currentIndex = e.item.index,
                                num = currentIndex - 2;//現在のインデックス番号
                            var max = totalCount - 1;//最後の番号

                            //3が最後
                            if (num === 0) {
                                if ($target.eq(max).hasClass('is-active')) {
                                    $target.eq(max).addClass('is-hidden');
                                    setTimeout(function () {
                                        $target.removeClass('is-active is-hidden');
                                        $target.find($targetChildMain).addClass('is-active is-hidden');
                                        $target.find($targetChildSub).addClass('is-active is-hidden');
                                    }, 400);
                                }

                                setTimeout(function () {
                                    $target.eq(num).addClass('is-active');
                                    $target.eq(num).find($targetChildMain).addClass('is-active');
                                    $target.eq(num).find($targetChildSub).addClass('is-active');
                                }, 400);
                            }

                            if (num === 1) {
                                $target.eq(num - 1).addClass('is-hidden');
                                $target.eq(num - 1).find($targetChildMain).addClass('is-hidden');
                                $target.eq(num - 1).find($targetChildSub).addClass('is-hidden');


                                setTimeout(function () {
                                    $target.eq(num).addClass('is-active');
                                    $target.eq(num).find($targetChildMain).addClass('is-active');
                                    $target.eq(num).find($targetChildSub).addClass('is-active');
                                }, 400);
                            }

                            if (num === 2) {
                                $target.eq(num - 1).addClass('is-hidden');
                                $target.eq(num - 1).find($targetChildMain).addClass('is-hidden');
                                $target.eq(num - 1).find($targetChildSub).addClass('is-hidden');

                                setTimeout(function () {
                                    $target.eq(num).addClass('is-active');
                                    $target.eq(num).find($targetChildMain).addClass('is-active');
                                    $target.eq(num).find($targetChildSub).addClass('is-active');
                                }, 400);
                            }

                            if (num === 3) {
                                $target.eq(num - 1).addClass('is-hidden');
                                $target.eq(num - 1).find($targetChildMain).addClass('is-hidden');
                                $target.eq(num - 1).find($targetChildSub).addClass('is-hidden');

                                setTimeout(function () {
                                    $target.eq(num).addClass('is-active');
                                    $target.eq(num).find($targetChildMain).addClass('is-active');
                                    $target.eq(num).find($targetChildSub).addClass('is-active');
                                }, 400);
                            }


                            //クラスの付け替え処理
                            // function changeClasses(active, hidden) {
                            //   // $target.eq(active).addClass('is-active');
                            //   // $target.eq(hidden).addClass('is-hidden');
                            //   //
                            //   // if ( $hidden.hasClass('is-hidden')) {
                            //   //   $hidden.addClass('is-active');
                            //   // }
                            //   //
                            //   // if ( $hidden.hasClass('is-active')) {
                            //   //   $hidden.addClass('is-hidden');
                            //   // }
                            // }

                            // changeClasses(currentIndex, prevIndex);
                            // console.log(currentIndex);
                            // console.log(prevIndex);
                        }
                    }
                });
            });
        }

        /************************************
         * スクロールダウン
         ************************************/
        function scrollDown() {
            var $elMain = $('.l-main');
            var $btn = $('.js-scrolldown');

            if ($elMain.length === 0) {
                return false;
            }
            var $mainPos = $($elMain).offset().top;
            $btn.on('click', function () {
                $('body,html').animate({scrollTop: $mainPos}, 400, 'swing');
            });
        }

        /************************************
         * セレクトプルダウン
         ************************************/
        function pullDown() {
            var eve = {
                click: 'click',
                hover: {
                    "mouseenter": function () {
                        $(this).addClass('is-active');
                    },
                    "mouseleave": function () {
                        $(this).removeClass('is-active');
                    }
                }
            };

            var e = eve.click,
                $win = $(window);
            if ($win.innerWidth() > 750) {
                e = eve.hover;
            }

            $('.c-post-item__select').on(e, function () {
                $(this).toggleClass('is-active');
            });
        }

        /************************************
         * ScrollReveal
         ************************************/
        function scrollReveal() {
            window.sr = ScrollReveal({duration: 600}); //, mobile: false

            function domEach(items, callback) {
                if (typeof items === "string") {
                    var items = $(items);
                }
                for (var i = 0; i < items.length; i++) {
                    var item = items[i];
                    // callback = callback.bind(item)
                    callback(i, item);
                }
            }

            // sr.reveal(".c-main-visual-content", {delay: 0, scale: 1, duration: 1000, origin: 'bottom', distance: '20px',easing: 'ease-out',}, 100);
            sr.reveal(".c-page-header", {
                delay: 0,
                scale: 1,
                duration: 1000,
                origin: 'bottom',
                distance: '20px',
                easing: 'ease-out',
            }, 100);
            sr.reveal(".l-main.is-lower", {
                delay: 1200,
                scale: 1,
                duration: 2000,
                origin: 'bottom',
                distance: '50px',
            }, 100);
            sr.reveal(".heading.is-xlg", {
                delay: 300,
                scale: 1,
                duration: 1000,
                origin: 'left',
                distance: '50px',
            }, 100);
            sr.reveal(".c-panel-sm__title", {
                delay: 300,
                scale: 1,
                duration: 1000,
                origin: 'right',
                distance: '0px',
            }, 100);
            sr.reveal(".js-sr-heading", {
                delay: 300,
                scale: 1,
                duration: 1000,
                origin: 'bottom',
                distance: '20px',
                easing: 'ease-in-out'
            }, 100);
            sr.reveal(".js-sr-text", {
                delay: 600,
                scale: 1,
                duration: 1000,
                origin: 'bottom',
                distance: '50px',
                easing: 'ease-in-out'
            }, 100);
            sr.reveal(".c-concept", {delay: 600, scale: 1, duration: 1000, origin: 'bottom', distance: '64px'}, 100);
            sr.reveal(".c-concept__deco.is-left", {
                delay: 850,
                scale: 1,
                duration: 1000,
                origin: 'left',
                distance: '20px',
                easing: 'ease-in-out'
            }, 100);
            sr.reveal(".c-concept__deco.is-right", {
                delay: 850,
                scale: 1,
                duration: 1000,
                origin: 'right',
                distance: '20px',
                easing: 'ease-in-out'
            }, 100);
            sr.reveal(".c-pyramid-block__content ul", {
                delay: 600,
                scale: 1,
                duration: 1000,
                origin: 'right',
                distance: '20px',
                easing: 'ease-in-out'
            }, 100);

            var blocks01 = $(".c-about-block__block, .c-hero-block__block, .c-black-card__inner, .c-card-sm__inner, .c-half-block__inner");
            domEach(blocks01, function (key, item) {
                sr.reveal(item, {
                    scale: 1,
                    duration: 700,
                    delay: 300,
                    origin: 'bottom',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 200);
                sr.reveal(item.children[1], {
                    delay: 400,
                    scale: 1,
                    origin: 'bottom',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[2], {
                    delay: 500,
                    scale: 1,
                    origin: 'bottom',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[3], {
                    delay: 600,
                    scale: 1,
                    origin: 'bottom',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[4], {
                    delay: 700,
                    scale: 1,
                    origin: 'bottom',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[5], {
                    delay: 800,
                    scale: 1,
                    origin: 'bottom',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[6], {
                    delay: 900,
                    scale: 1,
                    origin: 'bottom',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[7], {
                    delay: 1000,
                    scale: 1,
                    origin: 'bottom',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[8], {
                    delay: 1100,
                    scale: 1,
                    origin: 'bottom',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[9], {
                    delay: 1200,
                    scale: 1,
                    origin: 'bottom',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[10], {
                    delay: 1300,
                    scale: 1,
                    origin: 'bottom',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
            });

            var blocks02 = $(".c-page-header__inner, .c-generation-block__block .heading");
            domEach(blocks02, function (key, item) {
                sr.reveal(item, {
                    scale: 1,
                    duration: 1000,
                    delay: 100,
                    origin: 'top',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 200);
                sr.reveal(item.children[1], {
                    delay: 200,
                    scale: 1,
                    origin: 'top',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[2], {
                    delay: 300,
                    scale: 1,
                    origin: 'top',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[3], {
                    delay: 400,
                    scale: 1,
                    origin: 'top',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[4], {
                    delay: 500,
                    scale: 1,
                    origin: 'top',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[5], {
                    delay: 600,
                    scale: 1,
                    origin: 'top',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[6], {
                    delay: 700,
                    scale: 1,
                    origin: 'top',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[7], {
                    delay: 800,
                    scale: 1,
                    origin: 'top',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[8], {
                    delay: 900,
                    scale: 1,
                    origin: 'top',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
                sr.reveal(item.children[9], {
                    delay: 1000,
                    scale: 1,
                    origin: 'top',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 300);
            });

            var blocks03 = $(".c-pyramid-block__content ul");
            domEach(blocks03, function (key, item) {
                sr.reveal(item, {
                    scale: 1,
                    duration: 600,
                    delay: 100,
                    origin: 'right',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 0);
                sr.reveal(item.children[1], {
                    delay: 200,
                    scale: 1,
                    origin: 'right',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 0);
                sr.reveal(item.children[2], {
                    delay: 300,
                    scale: 1,
                    origin: 'right',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 0);
                sr.reveal(item.children[3], {
                    delay: 400,
                    scale: 1,
                    origin: 'right',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 0);
                sr.reveal(item.children[4], {
                    delay: 500,
                    scale: 1,
                    origin: 'right',
                    distance: '20px',
                    easing: 'ease-in-out'
                }, 0);
            });

            function myCallback(el) {
                el.classList.add('is-animating');
            }

            ScrollReveal({mobile: true}).reveal('.c-top-service__image', {delay: 600, beforeReveal: myCallback});
        }

        /************************************
         * particlesJS
         ************************************/
        function particleJS() {
            if ($("#particles-js").length <= 0) {
                return false;
            }
            if (navigator.platform.indexOf("Win") != -1) {
                return false;
            }
            particlesJS.load('particles-js', '/wp-content/themes/mitsufuji/html/dist/assets/js/particles.json', function () {
                console.log('callback - particles-js config loaded');
            });
        }

        /************************************
         * メインヴィジュアル snsアイコン
         ************************************/
        function mainVisualSns() {
            var $el = $('.js-sns-icon');
            var $el_low = $('.c-banner');
            var winWidth = $(window).innerWidth();
            if ($el.length === 0 || $el_low.length === 0 || winWidth < 750) {
                return false;
            }
            $el.clone().appendTo('body').addClass('is-clone');
            var $el_clone = $('.js-sns-icon.is-clone');
            if ($el_clone.length !== 0) {
                $(window).on('scroll', function () {
                    var elOffsetTop = $el.offset().top;
                    var elLowOffsetTop = 4000;
                    var winTop = $(window).scrollTop();
                    if (winTop > elOffsetTop) {
                        $el_clone.addClass('is-fixed')
                    }
                    if (winTop > elLowOffsetTop || winTop < elOffsetTop) {
                        $el_clone.removeClass('is-fixed')
                    }
                });
            }
        }

        $(function () {
            slick();
            pullDown();
            futureSlider();
            mainVisualImage();
            //mainVisualSlider();
            mainVisualSns();
            scrollDown();
            scrollReveal();
            particleJS();
            // buildFormat();
        });
    }
}

window
    .GApp = new App();


